<template>
  <div id="linePointChartComponent">
    <div id="chartBox" ref="charBox"></div>
  </div>
</template>
<script>
import echarts from "echarts/lib/echarts";
import { energyDataType, dateType } from "@/utils/typeParam";
// 引入折线图
import "echarts/lib/chart/line";
import "echarts/lib/component/title";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/dataZoom";

export default {
  name: "linePointChart",
  data() {
    return {
      energyName: "",
      typeUnit: "",
      seriesDataArr: []
    };
  },
  props: {
    dataSource: Object,
    energyType: "",
    curDateType: Number
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.charBox);
    this.initData();
  },
  methods: {
    //根据类型判断颜色
    getTypeColor() {
      switch (this.energyType) {
        case energyDataType.electricity:
          this.$set(this, "energyName", "电量");
          this.$set(this, "typeUnit", "(°)");
          return "#F07878";
        case energyDataType.waterYield:
          this.$set(this, "energyName", "水量");
          this.$set(this, "typeUnit", "(L)");
          return "#4A9AF4";
        case energyDataType.gas:
          this.$set(this, "energyName", "气量");
          this.$set(this, "typeUnit", "(m³)");
          return "#F38F3F";
        default:
          return "#F07878";
      }
    },
    //规整线颜色数组
    setBarColor(dataArr) {
      var colorStr = this.getTypeColor();
      //规整颜色
      var flag = true;
      var index = 0;
      var segmentValue = 0;
      var nowDate = new Date();
      switch (this.curDateType) {
        case dateType.hourType:
          segmentValue = nowDate.getHours();
          break;
        case dateType.dayType:
          segmentValue = nowDate.getDay();
          break;
        case dateType.monthType:
          segmentValue = nowDate.getMonth();
          break;
        case dateType.yearType:
          segmentValue = nowDate.getYear();
          break;
        default:
          break;
      }
      var yesterdayData = []; //旧数据
      var todayData = []; //新数据
      this.dataSource.timeArr.forEach(value => {
        if (parseInt(value) > segmentValue) {
          todayData.push(null);
          yesterdayData.push(dataArr[index]);
        } else {
          yesterdayData.push(null);
          todayData.push(dataArr[index]);
        }
        index++;
      });
      this.$set(this, "seriesDataArr", [
        {
          type: "line",
          name: this.energyName,
          itemStyle: {
            color: colorStr
          },
          lineStyle: {
            color: colorStr
          },
          data: todayData,
        },
        {
          type: "line",
          name: this.energyName,
          itemStyle: {
            color: "#CCC"
          },
          lineStyle: {
            color: "#CCC"
          },
          data: yesterdayData,
        }
      ]);
    },
    initData() {
      var colorStr = this.getTypeColor();
      if (this.dataSource.timeArr.length == 0) {
        this.dataSource.timeArr = [];
      } else {
        //数据处理
        var dataArr = [];
        this.dataSource.dataArr.forEach(value => {
          dataArr.push(value / 100);
        });
        this.setBarColor(dataArr);
      }

      var option = {
        title: {
          text: this.dataSource.title + " " + this.typeUnit,
          textStyle: {
            color: "#000",
            fontSize: "16"
          },
          bottom: 0,
          left: "center"
        }, 
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            },
            textStyle: {
              color: "#999"
            }
          }
        },
        grid: {
          show: true,
          borderWidth: 0,
          top: 10,
          bottom: "52",
          textStyle: {
            color: "#999"
          }
        },
        calculable: true,
        xAxis: {
          type: "category",
          boundaryGap: false,
          splitLine: {
            show: false
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            interval: 0 //设置成0，强制显示所有刻度
          },
          data: this.dataSource.timeArr
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: true //显示分割区域
          },
          axisLine: {
            lineStyle: {
              color: "#999"
            }
          },
          axisTick: {
            show: true //显示刻度
          },
          axisLabel: {
            interval: 0 //显示所有标签
          },
          axisLabel: {
            formatter: "{value}" + " " + this.typeUnit
          }
        },
        dataZoom: [
          {
            type: "inside",
            show: false,
            xAxisIndex: [0],
            height: 1,
            start: 1,
            end: 100
          }
        ],
        series: this.seriesDataArr
      };
      this.myChart.setOption(option);
    }
  }
};
</script>

<style scoped>
#linePointChartComponent {
  width: 100%;
  height: 100%;
}
#chartBox {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/subComponents/linePointChartComponent.vue